export const localeList = [
	'fr-FR',
	'fr-BE',
	'fr-CH',
	'nl-BE',
	'de-DE',
	'de-AT',
	'de-CH',
	'en-US',
	'en-GB',
	'en-IE',
	'es-ES',
	'it-IT',
	'it-CH',
	'nl-NL',
	'pt-PT',
] as const;
